import * as React from 'react'

const SvgQuestionmarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.286 2h1.428C13.095 2 15 3.875 15 6.219c0 2.343-1.905 4.218-4.286 4.218v1.876H8.81v-3.75h1.904c1.334 0 2.381-1.032 2.381-2.344 0-1.313-1.047-2.344-2.38-2.344h-1.43c-1.333 0-2.38 1.031-2.38 2.344v.468H5V6.22C5 3.875 6.905 2 9.286 2zm1.905 13.594c0 .776-.64 1.406-1.43 1.406-.788 0-1.428-.63-1.428-1.406 0-.777.64-1.406 1.429-1.406s1.428.63 1.428 1.406z"
      fill="#163250"
    />
  </svg>
)

export default SvgQuestionmarkIcon
